import api from "../index";
import { apiUrl, constant } from "../../utils/constants";
import axios from "axios";
import { config } from "../../utils/helper"

export const GetNotifications = () => api.get(`${constant.V1}${apiUrl.notifications}/`)
export const MarkNotificationAsRead = (id) => api.post(`${constant.V1}${apiUrl.notifications}/${id}${apiUrl.read}/`)
export const MarkAllNotificationAsRead = () => api.post(`${constant.V1}${apiUrl.notifications}${apiUrl.read_all}/`)
